// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__K7Xi7","dot":"Loading_dot__72DUF","wave":"Loading_wave__pqq4a"};